import React from 'react';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { RemoveProjectForm } from 'modules/components/layer12';

export type RemoveProjectModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemoveProjectModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Remove project'
      subTitle='This can not be undone.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <RemoveProjectForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
